import React from 'react';
import { cn } from '@/lib/utils';

const slug = (s) =>
  String(s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const QuickActionChips = ({ actions, onSelect, disabled, className }) => (
  <div className={cn('flex flex-wrap gap-2', className)}>
    {actions.map((action) => (
      <button
        key={action.id || action.label}
        type="button"
        disabled={disabled}
        onClick={() => onSelect(action)}
        data-testid={`romilda-ai-quick-action-${action.id || slug(action.label)}`}
        className="rounded-full border border-[color:var(--rmh-border-strong)] px-3.5 py-[7px] text-[0.74rem] font-medium tracking-[0.01em] text-[color:var(--rmh-ink-2)] transition-[background-color,border-color,color] duration-300 hover:border-[color:var(--rmh-ink)] hover:bg-[color:var(--rmh-surface-inset)] hover:text-[color:var(--rmh-ink)] disabled:pointer-events-none disabled:opacity-50"
        style={{ backgroundColor: 'var(--rmh-surface)' }}
      >
        {action.label}
      </button>
    ))}
  </div>
);

export default QuickActionChips;
